'use client'
import { Button } from "@/components/ui/button";
import { ArrowLeft, UserCircle } from "lucide-react"

import { useRouter } from "next/navigation"

import dynamic from "next/dynamic";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import Image from "next/image"
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../context/authContext";
import { clearAuth } from "../config/redux/slices/authAndAddressSlice"; // Import clearAuth
import { useState,useRef,useEffect } from "react"; // Import useState

// Dynamic import for BottomNavigationBar
const BottomNavigationBar = dynamic(() => import('./BottomNavigationBar'), {
  ssr: false,
  loading: () => null // or a loading placeholder if you prefer
});
const LoginModal = dynamic(() => import('./LoginModal'), { // Dynamic import for LoginModal
  ssr: false,
  loading: () => null
});
const COLORS = {
  kWhite: "#FFFFFF",
  inputBorder: "#E0E0E0",
  inputBackground: "#F0F0F0",
  primaryFontColor: "#333333",
  secondaryFontColor: "#666666",
  primaryColor: "#00489b",
  kBlack: "#000000",
}


// function BottomNavigationBar() {
//   const pathname = usePathname()


//   const navItems = [
//     { name: "Home", icon: faHome, href: "/" },
//     { name: "Bookings", icon: faReceipt, href: "/booking" },
//     { name: "Cart", icon: faShoppingCart, href: "/cart" },
//     { name: "Profile", icon:  faUser, href: "/profile" },
//   ]

//   return (
//     <nav className="fixed bottom-5 left-3 right-3  z-50 md:hidden shadow-lg rounded-3xl" style={{ background: COLORS.primaryColor }}>
//       <div className="flex justify-around items-center h-16 px-4">
//         {navItems.map((item) => {
//           const isActive = pathname === item.href
//           const iconColor = isActive ? COLORS.primaryColor : COLORS.kWhite;

//           return (
//             <Link key={item.name} href={item.href} className="flex flex-col items-center justify-center flex-1">
//               <div
//                 className={`relative p-2 rounded-full transition-colors duration-200 ${
//                   isActive ? "bg-white" : "bg-transparent"
//                 }`}
//               >
//                 {/* <item.icon className="h-6 w-6" style={{ color: isActive ? COLORS.primaryColor : COLORS.kWhite }} /> */}
//                  <FontAwesomeIcon color={iconColor  } className="h-6 w-6" icon={item.icon} />

//               </div>

//             </Link>
//           )
//         })}
//       </div>
//     </nav>
//   )
// }
const CartHeader = () => {
  const router = useRouter();

  const { logout, login } = useAuth()
  const dispatch = useDispatch()
  const { token } = useSelector((state) => state.auth)
  const Userprofile = useSelector((state) => state.auth.Userprofile);
  const [showLoginModal, setShowLoginModal] = useState(false); // State for LoginModal
  const Logout = () => {
    logout()
    toast.success("Logout Successfully")
    dispatch(clearAuth())
  }
   const menuRef = useRef(null);
    const [open, setOpen] = useState(false);
    useEffect(() => {
      function handleClickOutside(e) {
        if (menuRef.current && !menuRef.current.contains(e.target)) {
          setOpen(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

  return (
    <header className="w-full h-[50px] md:h-[75px] bg-white flex justify-between items-center fixed top-0 z-30"
      style={{ background: COLORS.kWhite, borderBottom: `1px solid ${COLORS.inputBorder}` }}>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full w-full flex items-center justify-between">
        <Button
          variant="ghost"
          size="lg"
          onClick={() => router.back()}
          className="h-16 w-16 md:hidden" // hide on md and above
        >
          <ArrowLeft className="h-10 w-10" />
        </Button>

        {/* Title for mobile, Logo for desktop */}
        <div className="md:hidden flex-1 text-center">
          <h1 className="text-xl font-bold" style={{ color: COLORS.primaryFontColor }}>Your Cart</h1>
        </div>
        <div
          className="hidden md:flex flex-col items-start cursor-pointer mt-2"
          onClick={() => router.push("/")}
        >
          <Image
            src="/images/sortkaro_login_logo.png"
            height={200}
            width={170}
            alt="SortKaro"
            style={{ width: 'auto', height: 'auto' }}
          />
        </div>

         <div className="relative inline-block" ref={menuRef}>
                        {/* Trigger Button */}
                        <button
                          className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
                          style={{ color: COLORS.primaryColor }}
                          onClick={() => setOpen((prev) => !prev)}
                        >
                          <UserCircle className="h-6 w-6" />
                        </button>
        
                        {/* Dropdown Menu */}
                        {open && (
                          <div className="absolute right-0 top-full mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-md z-50">
                            {token && Userprofile?.name && (
                              <div className="px-4 py-2 font-semibold text-gray-700 cursor-default">
                                {Userprofile.name}
                              </div>
                            )}
        
                            <div
                              className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-700"
                              onClick={() => {
                                router.push("/booking");
                                setOpen(false);
                              }}
                            >
                              My Booking
                            </div>
        
                            {token ? (
                              <div
                                className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-700 font-medium"
                                onClick={() => {
                                  Logout();
                                  setOpen(false);
                                }}
                              >
                                Logout
                              </div>
                            ) : (
                              <div
                                className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-700 font-medium"
                                onClick={() => {
                                  setShowLoginModal(true);
                                  setOpen(false);
                                }}
                              >
                                Login
                              </div>
                            )}
                          </div>
                        )}
                      </div>
      </div>
      <BottomNavigationBar />
      {/* Render LoginModal */}
      <LoginModal show={showLoginModal} onClose={() => setShowLoginModal(false)} />


    </header>
  );
};

export default CartHeader;
